import { useId } from 'react';
import styles from './Toggle.module.css';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  id?: string;
}

// On-brand on/off switch, token-driven and built locally so it can later be
// promoted into qampo-ui-library. Replaces the library Switch + SwitchLabelWrapper.
export const Toggle = ({ checked, onChange, label, disabled = false, id }: ToggleProps) => {
  const generatedId = useId();
  const labelId = label ? id ?? generatedId : undefined;

  const control = (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-labelledby={labelId}
      disabled={disabled}
      className={`${styles.track} ${checked ? styles.trackChecked : ''}`}
      onClick={() => onChange(!checked)}
    >
      <span className={styles.thumb} />
    </button>
  );

  if (!label) return control;

  return (
    <div className={styles.wrapper}>
      <span id={labelId} className={styles.label}>
        {label}
      </span>
      {control}
    </div>
  );
};
